export default "__VITE_ASSET__6debd6d5__"